export default "__VITE_ASSET__49f76285__"